module.exports = __webpack_public_path__ + "img/weixin.fa2c8c7a.jpg";